import { render, staticRenderFns } from "./NormalSearchNav231.vue?vue&type=template&id=3920dfbc&scoped=true"
import script from "./NormalSearchNav231.vue?vue&type=script&lang=js"
export * from "./NormalSearchNav231.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3920dfbc",
  null
  
)

export default component.exports